exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainMenu-1qAKH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-bottom:1px solid rgba(255,255,255,.3);padding-bottom:20px;margin-bottom:20px}.controlMenu-GR9Px{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.navLink-1OpBw{font-weight:600}.navLink-1OpBw:not(:last-of-type){margin-bottom:20px}.navLink-1OpBw.light-2_9bg{color:#39395b}.navLink-1OpBw.active-3pLip{color:#1fadff}.navLink-1OpBw.disabled-tn8Du{color:#9196af !important;cursor:not-allowed}.theme-dark .mainMenu-1qAKH{border-bottom:1px solid rgba(255,255,255,.3)}.theme-light .mainMenu-1qAKH{border-bottom:1px solid #bababa}", ""]);

// exports
exports.locals = {
	"mainMenu": "mainMenu-1qAKH",
	"controlMenu": "controlMenu-GR9Px",
	"navLink": "navLink-1OpBw",
	"light": "light-2_9bg",
	"active": "active-3pLip",
	"disabled": "disabled-tn8Du"
};